import { gql } from 'apollo-angular';

export const RESERVE_CARD_ITEM = gql`
  mutation ReserveCardItem($cardId: ObjectId!, $itemIndex: Int!) {
    reserveCardItem(cardId: $cardId, itemIndex: $itemIndex) {
      consumed
      message
      success
    }
  }
`;

export const RELEASE_CARD_ITEM_RESERVE = gql`
  mutation ReleaseCardItemReserve($cardId: ObjectId!, $itemIndex: Int!) {
    releaseCardItemReserve(cardId: $cardId, itemIndex: $itemIndex) {
      consumed
      message
      success
    }
  }
`;

export const CART_SESSION_START = gql`
  mutation CartSessionStart {
    cartSessionStart {
      success
      message
      accessToken
    }
  }
`;

export const CART_SESSION_REFRESH = gql`
  mutation CartSessionRefresh {
    cartSessionRefresh {
      success
      message
      accessToken
    }
  }
`;

export const CART_SESSION_USER_LOGOUT = gql`
  mutation CartSessionUserLogout {
    cartSessionUserLogout {
      success
      message
      accessToken
    }
  }
`;
